import type {Environment} from '../../../../../types'
import type {HostMap} from '../../../types'
import {PRODUCTION} from './production'
import {TESTING} from './testing'
import {UNSTABLE} from './unstable'

export const YANDEX = {
  unstable: UNSTABLE,
  testing: TESTING,
  production: PRODUCTION,
} satisfies Record<Environment, HostMap>
